import { style } from 'typestyle';
import { color, important } from 'csx';
import { TEAL_PRIMARY, RED_PRIMARY } from 'src/utils/Style/Theme';
import { NestedCSSProperties } from 'typestyle/lib/types';

const gray = color('#dee2e6').toHexString();
const enabled = 'enabled';

const contentContainerStyle: NestedCSSProperties = {
  $debugName: 'massEditContainer',
  width: '70vw',
  height: '70vh',
  minWidth: '700px',
  margin: '0 auto',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  $nest: {
    '& article:first-child': {
      maxWidth: '35%',
    },
  },
};
const contentContainer = style(contentContainerStyle);
const contentContainerNoProductList = style({
  $debugName: 'massEditContainerv2',
  margin: '0 auto',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: 400,
});

const contentItemsContainer = style({
  $debugName: 'massEditContentItemsContainer',
  display: 'flex',
});
const verticalContentItemsContainer = style({
  $debugName: 'massEditVerticalContentItemsContainer',
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
});

const actionsContainer = style({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
});
const massEditActionButton = style({
  color: TEAL_PRIMARY,
  borderColor: 'transparent !important',
  backgroundColor: 'transparent !important',
  padding: '6px 8px',
  fontSize: '0.875rem',
  fontWeight: 500,
  border: 0,
  $nest: {
    '&:disabled': {
      color: '#9d9d9d',
    },
  },
});
const actionButton = style({
  width: 100,
  height: 40,
  marginRight: 5,
  border: 'none',
});
const contentItemProperties: NestedCSSProperties = {
  $debugName: 'massEditContentItem',
  padding: '1rem',
  margin: 'auto 0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  flex: '1 0 30%',
  maxWidth: '100%',
  maxHeight: '75%',
  minHeight: '75%',
};
const contentItem = style(contentItemProperties);
const contentItemNoProductList = style({
  $debugName: 'massEditContentItemV2',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  maxWidth: '100%',
  height: '100%',
  $nest: {
    ' .count-bottom': {
      marginTop: 'auto',
    },
  },
});

const dividerItem = style({
  flex: '0.25 0 4%',
});

const divider = style({
  border: `1px solid ${gray}`,
  height: '100%',
  margin: '0 auto',
});

const selectAllCheckbox = style({
  paddingLeft: important(0),
});

const itemCount = style({
  marginLeft: '0.5rem',
  fontSize: '0.85rem',
});

const sectionTitle = style({
  $debugName: 'massEditSectionTitle',
  fontWeight: 'bold',
  fontSize: '1.2rem',
  marginBottom: '1.5rem',
});

const subSectionTitle = style({
  $debugName: 'massEditSubSectionTitle',
  fontSize: '0.9rem',
  fontWeight: 'bold',
  marginBottom: '1rem',
});

const sectionContent = style({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const sectionContentItem = style({
  $debugName: 'massEditSectionContentItem',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '1rem',
  $nest: {
    '&:first-child > div:nth-child(2)': {
      // override styles are not accepted on WeekRangePicker
      maxWidth: '100%',
    },
  },
});

const multiSelectSection = style({
  $debugName: 'massEditMultiSelectSection',
});

const multiSelectSearchContainer = style({
  marginBottom: 20,
  $nest: {
    input: {
      display: 'block',
      width: '100%',
      height: 'calc(1.5em + .75rem + 2px)',
      padding: '.375rem .75rem',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
      color: '#495057',
      backgroundColor: ' #fff',
      backgroundClip: 'padding-box',
      border: '1px solid #ced4da',
      borderRadius: 0,
      transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',
    },
  },
});

const multiSelectDetailsContainer = style({
  display: 'flex',
  fontSize: '0.85rem',
  justifyContent: 'space-between',
  alignItems: 'baseline',
});

const multiSelectItemsContainer = style({
  $debugName: 'multiSelectItemsContainer',
  height: '30vh',
  overflow: 'auto',
});

const multiSelectItemContainer = style({
  $debugName: 'massEditMultiSelectItemContainer',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: '50px',
  fontSize: '0.9rem',
  marginBottom: '0.1rem',
  paddingLeft: '1rem',
  border: `1px solid ${gray}`,
  $nest: {
    [`&.${enabled}`]: {
      color: '#ffffff',
      backgroundColor: TEAL_PRIMARY,
    },
  },
});

const massEditInput = style({
  fontSize: '0.8rem',
  height: '38px',
  width: '100%',
  outline: 0,
  border: '1px solid hsl(0, 0%, 80%)',
  borderRadius: '4px',
  $nest: {
    '&:disabled': {
      cursor: 'not-allowed',
    },
  },
});

const massEditMuiInput = style({
  $nest: {
    '&.s5-MuiInputBase-root': {
      height: '100%',
    },
    '& input': {
      padding: 0,
      paddingLeft: 5,
      '-moz-appearance': 'textfield', // hide number spinners in firefox
      $nest: {
        '&::-webkit-outer-spin-button': {
          display: 'none',
        },
        '&::-webkit-inner-spin-button': {
          display: 'none',
        },
      },
    },
  },
});

const modifierInput = style({
  $debugName: 'massEditModifierInput',
  $nest: {
    // stretch input suggest
    'div.input-group > div': {
      width: '100%',
    },
  },
});
const actionButtonGroup = style({
  $debugName: 'actionButtonGroup',
  $nest: {
    ' .massedit-count': {
      color: 'white',
    },
  },
});

const actionButtonButton = style({
  $debugName: 'actionButton',
  textTransform: important('none'),
});
const actionButtonIcon = style({
  $debugName: 'actionButtonIcon',
  paddingRight: 5,
});
const submitButtonContainer = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
});

export default {
  contentContainer,
  contentItemsContainer,
  verticalContentItemsContainer,
  contentContainerNoProductList,
  actionsContainer,
  actionButton,
  contentItem,
  contentItemNoProductList,
  dividerItem,
  divider,
  sectionTitle,
  sectionContent,
  sectionContentItem,
  subSectionTitle,
  multiSelectSection,
  multiSelectSearchContainer,
  multiSelectDetailsContainer,
  multiSelectItemsContainer,
  multiSelectItemContainer,
  selectAllCheckbox,
  itemCount,
  enabled,
  massEditInput,
  massEditMuiInput,
  modifierInput,
  actionButtonButton,
  actionButtonGroup,
  actionButtonIcon,
  submitButtonContainer,
  massEditActionButton,
};
